<template><section><!-- ---
title: CSS实践系列之三角形
date: 2022-10-11 
tags: CSS实践
set: CSSPractise
--- -->
<pre v-pre><code v-pre class="language-html"><span class="hljs-meta">&lt;!DOCTYPE <span class="hljs-meta-keyword">html</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">html</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">head</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">meta</span> <span class="hljs-attr">charset</span>=<span class="hljs-string">"utf-8"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">title</span>&gt;</span>test<span class="hljs-tag">&lt;/<span class="hljs-name">title</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">style</span>&gt;</span><span class="css">
            <span class="hljs-selector-class">.triangle1</span> {
                <span class="hljs-attribute">width</span>: <span class="hljs-number">0</span>;
                <span class="hljs-attribute">height</span>: <span class="hljs-number">0</span>;
                <span class="hljs-attribute">border-style</span>: solid;
                <span class="hljs-attribute">border-width</span>: <span class="hljs-number">50px</span>;
                <span class="hljs-attribute">border-color</span>: transparent transparent red transparent;
            }

            <span class="hljs-selector-class">.triangle2</span> {
                <span class="hljs-attribute">width</span>: <span class="hljs-number">0</span>;
                <span class="hljs-attribute">height</span>: <span class="hljs-number">0</span>;
                <span class="hljs-attribute">border</span>: <span class="hljs-number">50px</span> solid transparent;
                <span class="hljs-attribute">border-top-color</span>: red;
            }  
        </span><span class="hljs-tag">&lt;/<span class="hljs-name">style</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">head</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">body</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"triangle1"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"triangle2"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">body</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">html</span>&gt;</span>
</code></pre>
</section></template>
<style>
            .triangle1 {
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 50px;
                border-color: transparent transparent red transparent;
            }

            .triangle2 {
                width: 0;
                height: 0;
                border: 50px solid transparent;
                border-top-color: red;
            }  
        </style>
